<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/classification/inspection/standards/item/tabPage"
      getKey="rows" :columns="columns">
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
          @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #chouyangguocheng="scope">
        <span
          v-if="scope.row.samplingProcedure">{{ scope.row.samplingProcedure.code }}/{{ scope.row.samplingProcedure.desc }}</span>
      </template>
      <!--检验标识-->
      <template #jianyanbiaoshi="scope">
        <el-input disabled
              :value="$t(store.state.dictJson['QUALITY_INSPECTION_STANDARD_FLAG'][$attrs.standards.inspectionClassification])"></el-input>
      </template>
      <!-- <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row); getInspectionList()">{{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"
              @click="yt.remove(scope.row, '/web/classification/inspection/standards/item/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template> -->
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_quality_management_inspection_standard_standards_item_tab',
  components: {
  },
  data() {
    return {
      material: this.$attrs.details.material,
      show: false,
      typeList: [],
      columns: [{
        label: 'gongxu',
        prop: 'procedure',
      }, {
        label: 'jianyanleibie',
        prop: 'inspectionCategory',
        width: 130,
      }, {
        label: 'jianyanxiangmu',
        prop: 'inspectionProject',
        width: 180,
      }, {
        label: 'jianyangongju',
        prop: 'inspectionTools',
        width: 130,
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },
      {
          label: 'jianyanbiaoshi',
          prop: 'inspectionMark',
          type: 'dictionary',
          key: 'QUALITY_INSPECTION_STANDARD_FLAG',
          width: 150
      },
      {
        label: 'jianyanfangshi',
        prop: 'inspectionMethod.name',
        width: 180,
      },
      {
        label: 'shifoubijian',
        prop: 'must',
        type: 'bool',
        iln18: ['shi', 'fou'],
      },
      {
        label: 'jianyanyiju',
        prop: 'inspectionAccording',
        width: 180,
      },
      {
        label: 'quexiandengji',
        prop: 'defectLevel',
        width: 180,
      },
      {
        label: 'chouyangguocheng',
        type: 'slot',
        width: 180,
      },
      {
        label: 'guigexiaxian',
        prop: 'specLowerLimit',
        width: 180,
      }, {
        label: 'guigeshangxian',
        prop: 'specUpLimit',
        width: 180,
      }, {
        label: 'jiliangdanwei',
        prop: 'measurementUnit',
        width: 180,
      }
      ]
    };
  },
  created() {

    setTimeout(() => {
      this.yt.conditions = {
        inspectionType: this.$attrs.details.type,
      }
      if(this.material===undefined || this.material===null || !this.material.checkoutType){
        this.yt.conditions.checkoutType = null
      }else{
        this.yt.conditions.checkoutType = this.material.checkoutType
      }
      this.yt.get(1);
      this.utils.event_hub.$on('STANDARDS_ITEM_REFRESH', () => {
        this.yt.get(1);
      })
    }, 300)
  },

  methods: {
    async getInspectionList() {
      this.showTab = false
      return await this.http.get('/web/quality/inspection/method/page?' + this.qs.stringify({
        pageNum: 1,
        pageSize: 100,
        inspectionType: this.$attrs.standards.inspectionType
        // orderBy: 'sort',
      })).then(response => {
        this.typeList = response.data.rows || []
      }).catch(() => {

      })
    },
    beforeAdd(params, url) {
      params.inspectionStandardsId = this.$attrs.standards.id
      return params
    }
  }
};
</script>
